export const confirmEmail = {
  success: 'E-mail confirmado con éxito',
}



// WEBPACK FOOTER //
// ./src/sections/confirmEmail/text.js